const RemainingStep = (props: any) => (
	<svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M8.6665 0.25C4.38525 0.25 0.916504 3.71875 0.916504 8C0.916504 12.2812 4.38525 15.75 8.6665 15.75C12.9478 15.75 16.4165 12.2812 16.4165 8C16.4165 3.71875 12.9478 0.25 8.6665 0.25ZM8.6665 14.25C5.21338 14.25 2.4165 11.4531 2.4165 8C2.4165 4.54688 5.21338 1.75 8.6665 1.75C12.1196 1.75 14.9165 4.54688 14.9165 8C14.9165 11.4531 12.1196 14.25 8.6665 14.25Z"
			fill="#C1C9D2"
		/>
	</svg>
);
export default RemainingStep;
